const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedUser: null,
  isps: [],
  plans: [],
  cities: [],
};

const noInteresados = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        selectedUser: null,
      };
    case 'GET_USER':
      return {...state, selectedUser: action.selectedUser};
    case 'GET_ALL_DATA_ISP_X':
      return {...state, isps: action.data};
    case 'GET_ALL_DATA_PLAN':
      return {...state, plans: action.data};
    case 'GET_ALL_DATA_CITY':
      return {...state, cities: action.data};
    case 'INITIATE_INSTANCE':
    case 'ADD_USER':
    case 'DELETE_USER':
      return {...state};
    default:
      return {...state};
  }
};

export default noInteresados;
